export function BubbleIcon({ size = 24, color = "currentColor", strokeWidth = 40 }: { size?: number; color?: string; strokeWidth?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="165" cy="95" r="55" stroke={color} strokeWidth={strokeWidth} />
      <circle cx="380" cy="175" r="70" stroke={color} strokeWidth={strokeWidth} />
      <circle cx="170" cy="335" r="110" stroke={color} strokeWidth={strokeWidth} />
      <path
        d="M155 300 C135 285 110 290 105 315 C100 340 120 355 140 350 C145 380 170 395 190 385 C210 375 215 350 205 325 C195 300 175 290 155 300"
        fill={color}
      />
    </svg>
  );
}
